import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    id: 'back',
    defaultMessage: 'Back',
  },
  crop: {
    id: 'crop',
    defaultMessage: 'Crop',
  },
  targetYield: {
    id: 'targetYield',
    defaultMessage: 'Target Yield',
  },
  field: {
    id: 'comments.field',
    defaultMessage: 'Field',
  },
  dateCreated: {
    id: 'comments.dateCreated',
    defaultMessage: 'Date Created',
  },
  Bushels: {
    id: 'Bushels',
    defaultMessage: 'bu',
  },
  Kgs: {
    id: 'Kgs',
    defaultMessage: 'kg',
  },
  Tons: {
    id: 'tons',
    defaultMessage: 'tons',
  },
  Lbs: {
    id: 'Lbs',
    defaultMessage: 'lbs',
  },
  addComment: {
    id: 'addComment',
    defaultMessage: 'Add Comment',
  },
  comments: {
    id: 'comments.comments',
    defaultMessage: 'Comments',
  },
  customer: {
    id: 'customer',
    defaultMessage: 'Customer',
  },
  recordDate: {
    id: 'recordDate',
    defaultMessage: 'Record Date',
  },
  samples: {
    id: 'samples',
    defaultMessage: 'Samples',
  },
  farm: {
    id: 'comments.farm',
    defaultMessage: 'Farm',
  },
  headerText1: {
    id: 'headerText1',
    defaultMessage: 'All recommended rates are ELEMENTAL.',
  },
  headerText2: {
    id: 'headerText2',
    defaultMessage: 'Reference your Lab Results while reviewing these comments.',
  },
  headerText3: {
    id: 'headerText3',
    defaultMessage: 'Create a product specific recommendation to see how these rates will apply.',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading Data',
  },
  recommendedRatesWarning: {
    id: 'recommendedRatesWarning',
    defaultMessage:
      'In some cases the FE Soils recommendations may be more than what you would like to apply ' +
      'or what your equipment will allow you to apply.  When you create controller files to apply variable ' +
      'rate fertilizer, you can limit the maximum amount applied of any specific nutrient if you choose.' +
      'If you have questions about this, please contact us.',
  },
  commentNotAvailable: {
    id: 'commentNotAvailable',
    defaultMessage: 'Comments are only available for jobs with status "Results Posted".',
  },
})
